import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clptxn',
  templateUrl: './clptxn.component.html',
  styleUrls: ['./clptxn.component.css']
})
export class ClptxnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
